import React from "react";
import "../../hospitalStatic.css";
import { Checkbox } from "@fluentui/react/lib/Checkbox";
import { Icon } from "@fluentui/react";

const CustomCheckBox = (props) => {
  return (
    <>
      <div className={props.parentClassName}>
        <div style={{ marginBottom: "0px" }} className="form-field-value">
          <Checkbox
            style={{
              fontWeight: "400",
            }}
            defaultChecked={props.values}
            value={props.values}
            label={props.label}
            onChange={props.onChangeCustom}
            boxSide="start"
          />
          <span
            style={{
              color: "#4A4A4A",
              fontSize: "13px",
              fontWeight: "300",
              marginLeft: "28px",
              display:"flex"
            }}
          >
            {/* <div style={{lineHeight:'26px'}}>
            <Icon
              iconName="Info"
              style={{
                color: "#4A4A4A",
                fontSize: 14,
                marginRight: "10px",
              }}
            ></Icon>
            </div>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. */}
          </span>
        </div>
      </div>
    </>
  );
};

export default CustomCheckBox;
